import {ApiEndPoint} from "../../network/api_end_point";
import {apiCaller, getToken} from "../../network/network_helper";
import StringUtils from "../../utils/string_utils";

const apiEndPoint = new ApiEndPoint();
export const warehousesApiCall = async () => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.authBaseUrl + apiEndPoint.warehouseUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (e) {
        throw e;
    }
}
export const driverApiCall = async () => {
    try {
        const token = getToken();
        const channelId = localStorage.getItem('channelId');
        const response = await apiCaller(`${apiEndPoint.masterUrlWithChannelId(channelId)}drivers`, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                client_location_id: localStorage.getItem('clientLocationId'),
                status: StringUtils.active.toUpperCase(),
                source: apiEndPoint.source,
                page_size:5000,
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
}
export const countTaskApiCall = async () => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.countTaskUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                hub_id: localStorage.getItem('clientLocationId'),
                source: apiEndPoint.source
            }
        });
        return response;
    } catch (e) {
        throw e;
    }
}